var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name, _vm.spacing]},[_c('grid',{class:[{ 'grid--container': !_vm.fullwidth }, `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:`${_vm.name}__grid-item`,attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},[_c('div',{class:`${_vm.name}__items`},_vm._l((_vm.cms.stats),function(item,index){return _c('div',{key:index,class:`${_vm.name}__item`},[(item.heading)?_c('a-heading',{class:`${_vm.name}__heading`,attrs:{"cms":item}}):_vm._e(),_vm._v(" "),(item.copy)?_c('div',{class:`${_vm.name}__text`,domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(item.copy))}}):_vm._e()],1)}),0)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }